<!-- <app-navbar></app-navbar> -->
<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<div class="wccard d-flex justify-content-between mb-4">
  <div class="switch-box">
    <!-- <div class="switch-on">
      Personal
    </div>
    <div class="switch-off">
      Team Members
    </div> -->
    <ul class="nav nav-pills" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button data-testid="auto-app-reports-button-1" class="nav-link"  (click)="onTabChange('personal-reports')" [ngClass]="{'active': tabactive=='personal-reports'}" >Personal</button>
      </li>
      <li class="nav-item" role="presentation" *ngIf="role == 'team admin'">
        <button data-testid="auto-app-reports-button-2" class="nav-link"  (click)="onTabChange('team-members')" [ngClass]="{'active': tabactive=='team-members'}"> Team Members</button>
      </li>
    </ul>

  </div>
  <div class="wc-alert-info" *ngIf="teammemberRoute == 'team-members'">
    <span class="mr-3"><i class="fas fa-info-circle"></i></span>
    <span>The data of the selected </span>
    <span class="mx-1">"<i class="fas fa-check"></i>"</span>
    <span>team member in the <span class="font-weight-600">Team members</span> section will be visible</span>
  </div>
  <!-- class="date-selector" -->
  <div class="">
    <div class="dropdown dateRange">
      <button data-testid="auto-app-reports-button-3" class="date-rage-btn dropdown-toggle" type="button" id="dropdownMenuButton" appDropdownToggle aria-haspopup="true" aria-expanded="false">
       <span *ngIf="!selectedStartDate && !selectedEndDate"> Select date range</span>
       <span class="text-black" *ngIf="selectedStartDate && selectedEndDate">{{selectedStartDate | date: 'dd MMM yyyy'}} - {{selectedEndDate | date: 'dd MMM yyyy'}}</span>
       <span>
        <i class="far fa-calendar"></i>
      </span>
      </button>
      <div class="dropdown-menu p-3" aria-bs-labelledby="dropdownMenuButton" id="dropdown-reports">
      <form [formGroup]="startDateAndEndDateForm">

        <div class="d-flex ">
          <div class="mr-2">
            <p class="f-12 text-9696">Start date</p>
            <input data-testid="auto-app-reports-input-1" type="date" class="wc-form-control" formControlName="startDate" [(ngModel)]="startDate" name="startDate"  [value]="startDate | date:'yyyy-MM-dd'" (blur)="datePickerClosedStartDate($event)">
          </div>
          <div>
            <p class="f-12 text-9696">End date</p>
            <input data-testid="auto-app-reports-input-2" type="date" class="wc-form-control" formControlName="endDate" [(ngModel)]="endDate" name="endDate"  [value]="endDate | date:'yyyy-MM-dd'" (blur)="datePickerClosedEndDate($event)">

          </div>
        </div>
        <div *ngIf="startDateAndEndDateForm.hasError('dateRangeError')">
          <p class="error-message text-danger">Start date should not be greater than end date.</p>
        </div>

        <div class="d-flex justify-content-end w-100">
          <button data-testid="auto-app-reports-button-4" class="btn-trms-small ml-0 ms-auto" (click)="saveDates()" [disabled]="startDateAndEndDateForm.hasError('dateRangeError')" [ngClass] = "startDateAndEndDateForm.hasError('dateRangeError') ? 'disabled-button' : 'enabled-button'">Search</button>
        </div>

      </form>
      </div>
    </div>
    <!-- <input data-testid="auto-app-reports-input-3"  class="wc-form-control" placeholder=" date" onblur="(this.type='text')" onfocus="this.type='date'"> -->
    <!-- <span>Select date range</span>
    <span>
      <i class="far fa-calendar"></i>
    </span> -->
  </div>

</div>
<div class="tab-content" id="pills-tabContent">
  <div class="tab-pane fade show active" id="pills-personal" role="tabpanel" aria-labelledby="pills-personal-tab">
    <router-outlet></router-outlet>
    <!-- <app-personal-reports></app-personal-reports> -->
  </div>
  <!-- <div class="tab-pane fade" id="pills-teammember" role="tabpanel" aria-labelledby="pills-teammember-tab">
    <app-team-members-reports></app-team-members-reports>
  </div> -->
</div>
